import {
  PP_LEADS_FETCH_START,
  PP_LEADS_FETCH_SUCCUSS,
  PP_LEADS_FETCH_FAIL,
  P24_LEADS_FETCH_START,
  P24_LEADS_FETCH_SUCCUSS,
  P24_LEADS_FETCH_FAIL,
  PP_LISTINGS_ACTIVITY_FETCH_START,
  PP_LISTINGS_ACTIVITY_FETCH_SUCCUSS,
  PP_LISTINGS_ACTIVITY_FETCH_FAIL,
  FETCH_PPREF,
  FETCH_PPREF_SUCCESS,
  FETCH_PPREF_FAIL
} from "../store/types";
import { cloud_function_server_url } from "config";
export const fetchPPLeads = (token, date) => (dispatch) => {
  dispatch({ type: PP_LEADS_FETCH_START });

  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "text/xml");

    const raw = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">
    <soapenv:Header/>
    <soapenv:Body>
        <tem:ListingLeadDetailsFeed>
            <tem:Token>
                <tem:Digest>${token.Digest}</tem:Digest>
                <tem:UserName>${token.UserName}</tem:UserName>
                <tem:StampTime>${token.StampTime}</tem:StampTime>
                <tem:Expires>${token.Expires}</tem:Expires>
                <tem:UID>${token.UID}</tem:UID>
            </tem:Token>
            <tem:StartDate>${date}</tem:StartDate>
        </tem:ListingLeadDetailsFeed>
    </soapenv:Body>
</soapenv:Envelope>
    `;

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(
      `${cloud_function_server_url}/ListingLeadDetailsFeedPP`,
      requestOptions
    )
      .then((response) => {
        response;

        return response.text();
      })
      .then((result) => {
        dispatch({
          type: PP_LEADS_FETCH_SUCCUSS,
          payload: result
        });
      })
      .catch((error) => console.log("error", error));
  } catch (error) {
    console.log("Error fetching PP Leads:", error);
    dispatch({ type: PP_LEADS_FETCH_FAIL, payload: error });
  }
};

export const fetchP24Leads = () => (dispatch) => (firebase) => {
  dispatch({ type: P24_LEADS_FETCH_START });
  const { p24LeadsRef } = firebase;
  p24LeadsRef.on("value", (snapshot) => {
    if (snapshot.val()) {
      const data = snapshot.val();
      dispatch({ type: P24_LEADS_FETCH_SUCCUSS, payload: data });
    } else {
      dispatch({ type: P24_LEADS_FETCH_FAIL });
    }
  });
};

export const fetchPPListingsActivity = (token, data) => (dispatch) => {
  dispatch({ type: PP_LISTINGS_ACTIVITY_FETCH_START });

  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "text/xml");
    const raw = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">
    <soapenv:Header/>
    <soapenv:Body>
        <tem:GetListingEventFeedByFeedProvider>
            <tem:Token>
                <tem:Digest>${token.Digest}</tem:Digest>
                <tem:UserName>${token.UserName}</tem:UserName>
                <tem:StampTime>${token.StampTime}</tem:StampTime>
                <tem:Expires>${token.Expires}</tem:Expires>
                <tem:UID>${token.UID}</tem:UID>
            </tem:Token>
            <tem:continuationKey>${data.continuationKey}</tem:continuationKey>
            <tem:startDateTime>${data.date}</tem:startDateTime>
        </tem:GetListingEventFeedByFeedProvider>
    </soapenv:Body>
</soapenv:Envelope>
    `;
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };
    fetch(
      `${cloud_function_server_url}/getListingEventFeedByFeedProviderPP`,
      requestOptions
    )
      .then((response) => {
        response;
        return response.text();
      })
      .then((result) => {
        dispatch({
          type: PP_LISTINGS_ACTIVITY_FETCH_SUCCUSS,
          payload: result
        });
      })
      .catch((error) => console.log("error", error));
  } catch (error) {
    console.log("Error fetching PP Listings Activity:", error);
    dispatch({ type: PP_LISTINGS_ACTIVITY_FETCH_FAIL, payload: error });
  }
};

// export const fetchPPRef = (token, data) => (dispatch) => (firebase) => {
//   const { singleListingRef } = firebase;
//   dispatch({ type: FETCH_PPREF });
//   try {
//     const myHeaders = new Headers();
//     myHeaders.append("Content-Type", "text/xml");
//     const raw = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">
//     <soapenv:Header/>
//     <soapenv:Body>
//         <tem:GetReferenceNumberByListing>
//             <tem:Token>
//                 <tem:Digest>${token.Digest}</tem:Digest>
//                 <tem:UserName>${token.UserName}</tem:UserName>
//                 <tem:StampTime>${token.StampTime}</tem:StampTime>
//                 <tem:Expires>${token.Expires}</tem:Expires>
//                 <tem:UID>${token.UID}</tem:UID>
//             </tem:Token>
//             <tem:UniqueListingID>${data.web_Ref_No}</tem:UniqueListingID>
//             <tem:BranchId>${data.BranchPPId
// }</tem:BranchId>
//             <tem:listingType>${
//               data.type === "tolet" ||
//               data.type.toLowerCase().includes("to let") ||
//               data.type.toLowerCase().includes("rental")
//                 ? "Rental"
//                 : "Sale"
//             }</tem:listingType>
//         </tem:GetReferenceNumberByListing>
//     </soapenv:Body>
// </soapenv:Envelope>
//     `;
//     const requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: raw,
//       redirect: "follow"
//     };
//     fetch(`${cloud_function_server_url}/getPPRef`, requestOptions)
//       .then((response) => {
//         response;
//         return response.text();
//       })
//       .then(async (result) => {
//         await singleListingRef(listing.id).update({
//           ppref: result
//         });
//         console.log("PP Ref updated in Firebase", result);

//         dispatch({
//           type: FETCH_PPREF_SUCCESS,
//           payload: result
//         });
//       })
//       .catch((error) => console.log("error", error));
//   } catch (error) {
//     console.log("Error fetching PP Ref:", error);
//     dispatch({ type: FETCH_PPREF_FAIL, payload: error });
//   }
// };
export const fetchPPRef = (token, data) => (dispatch) => (firebase) => {
  const { singleListingRef, api } = firebase;
  dispatch({ type: FETCH_PPREF });
  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "text/xml");
    const raw = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">
    <soapenv:Header/>
    <soapenv:Body>
        <tem:GetReferenceNumberByListing>
            <tem:Token>
                <tem:Digest>${token.Digest}</tem:Digest>
                <tem:UserName>${token.UserName}</tem:UserName>
                <tem:StampTime>${token.StampTime}</tem:StampTime>
                <tem:Expires>${token.Expires}</tem:Expires>
                <tem:UID>${token.UID}</tem:UID>
            </tem:Token>
            <tem:UniqueListingID>${data.web_Ref_No}</tem:UniqueListingID>
            <tem:BranchId>${data.BranchPPId}</tem:BranchId>
            <tem:listingType>${data.type === "tolet" ||
        data.type.toLowerCase().includes("to let") ||
        data.type.toLowerCase().includes("rental")
        ? "Rental"
        : "Sale"
      }</tem:listingType>
        </tem:GetReferenceNumberByListing>
    </soapenv:Body>
</soapenv:Envelope>`;

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${cloud_function_server_url}/getPPRef`, requestOptions)
      .then((response) => response.text())
      .then(async (result) => {
        // Parse the XML response

        console.log('result', result);

        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(result, "text/xml");

        // Extract the value using the full namespace-aware path
        const resultElement = xmlDoc.getElementsByTagName("GetReferenceNumberByListingResult")[0];
        const extractedValue = resultElement ? resultElement.textContent : null;



        if (extractedValue) {
          dispatch(
            api.UpdateListing({
              id: data.id,
              ListingPPId: extractedValue,
              PPStatus: (data.PPStatus && extractedValue) ? data.PPStatus : extractedValue ? (data?.type === "tolet" || data?.type.includes("To Let")) ? "ToLet" : "ForSale" : null,
              publishedPP: true,
              syndicateFlags: {
                privateProperty: true,
                website: true,
                property24: true
              },
            })
          );

          console.log("PP Ref updated in Firebase", extractedValue);

          dispatch({
            type: FETCH_PPREF_SUCCESS,
            payload: extractedValue
          });
        } else {
          dispatch(
            api.UpdateListing({
              id: data.id,
              ListingPPId: null,
              publishedPP: false,
            })
          );

          dispatch({
            type: FETCH_PPREF_SUCCESS,
            payload: null
          });

        }
      })
      .catch((error) => {
        console.log("error", error);
        dispatch({ type: FETCH_PPREF_FAIL, payload: error });
      });
  } catch (error) {
    console.log("Error fetching PP Ref:", error);
    dispatch({ type: FETCH_PPREF_FAIL, payload: error });
  }
};